'use strict';

import _ from 'underscore';
import uikit from '../uikit';

var config = {
  inventoryRegion: {
    NorthAmericaComponents: 'NAC',
    AmericanComponentNorthAmerica: 'ACNA',
    AEPetsche: 'AEP'
  },
  paymentCode: {
    creditCard: 'CREDITCARD',
    paypal: 'PAYPAL',
    wireTransfer: 'WIRE',
    arrange: 'ARRANGE',
    other: 'OTHER',
    terms: 'TERMS',
    apply: 'APPLY LOC',
    link: 'LINK LOC'
  },
  orderConfirmationNotifications: {
    ukrainianCountryCode: 'UA',
    wireTransferLink: 'https://static2.arrow.com/wireinstructions/Arrow_Wire_Instructions_en_{0}.pdf'
  },
  manufacturer: {
    qualcomm: 'QUALCOMM'
  },
  csrImpersonation: { // removed key-value of checkIfUserDefaultPassword: 'GHA7654efahyvyq01Qbrulgkj8645ayhp' for ARW-34159
    csrPermission: 'PRIV_isr',
    csrBannerUrl: '/cart'
  },

  analytics: { // This needs to be moved to serverside config.json and fixed for the config transform
    triggers: {
      genericEvent: 'analyticsEvent',
      addToCart: 'addToCartDetails',
      addToCartSearch: 'addToCartSearch',
      orderConfirmation: 'orderConfirmation',
      removeFromCart: 'removeFromCart'
    },
    registrationEvent: {
      eventEmail: 'Click',
      category: 'Register',
      categoryEmail: 'Registration',
      actionArrow: 'Arrow.com',
      actionMyArrow: 'MyArrow',
      labelSuccess: 'Success',
      labelFail: 'Fail',
      labelPrefix: 'Email Sign Up - ',
      value: '0'
    },
    survey: {
      event: {
        productSearch: 'Product Search',
        productDetail: 'Product Detail',
        purchaseConfirmation: 'Purchase Confirmation'
      },
      eventPrefix: 'Survey - '
    },
    actionFieldLists: {
      searchPage: 'searchpage',
      designCenter: 'designcenter'
    },
    eventTypes: {
      Click: 'Click',
      LinkClick: 'linkclick',
      Hover: 'Hover',
      Error: 'Error',
      FormSubmission: 'FormSubmission',
      Popup: 'Popup',
      PromoClick: 'promotionClick',
      PromoImpression: 'promotionImpression',
      CheckoutOption: 'checkoutOption',
      DefaultSet: 'DefaultSet',
      DatasheetInteraction: 'datasheet_interaction'
    },
    actions: {
      Popup: 'Popup',
      ContactArrow: 'Contact Arrow',
      FindAnOffice: 'Find an Office',
      Chat: 'Chat',
      View: 'View',
      RegionSelect: 'RegionSelect',
      Download: 'Download',
      EngineerContact: 'EngineerContact',
      Hover: 'Hover',
      Site: 'Site',
      MyArrow: 'MyArrow',
      ArrowCom: 'ArrowCom',
      BannerClick: 'BannerClick',
      AddFilter: 'AddFilter',
      RemoveFilter: 'RemoveFilter',
      AddToCart: 'AddToCart',
      AddToCartSuccess: 'AddToCartSuccess',
      AddToCartFail: 'AddToCartFail',
      LanguageSelect: 'LanguageSelect',
      CurrencySelect: 'CurrencySelect',
      MenuClick: 'MenuClick',
      DivisionSelect: 'DivisionSelect',
      Backorder: 'Backorder',
      BackorderDeplete: 'BackorderDeplete',
      CallForPrice: 'CallForPrice',
      RemoveFromCart: 'RemoveFromCart',
      Play: 'Play',
      Subscribe: 'Subscribe',
      NoSearchResults: 'NoSearchResults',
      BannerImpression: 'BannerImpression',
      Product: 'Product',
      Share: 'Share',
      LaunchTool: 'LaunchTool',
      GetStarted: 'GetStarted',
      CreateProject: 'CreateProject',
      DuplicateProject: 'DuplicateProject',
      DeleteProject: 'DeleteProject',
      Enlarge: 'Enlarge',
      Buy: 'Buy',
      SaveToProject: 'SaveToProject',
      Click: 'Click',
      Fund: 'Fund',
      LoginAttempt: 'LoginAttempt',
      Pagination: 'Pagination',
      Search: 'Search',
      ClickEcommerce: 'ClickEcommerce',
      Ecliptek: 'Ecliptek',
      Quote: 'Quote',
      Verical: 'Verical',
      Update: 'Update',
      SearchBar: 'SearchBar',
      Request: 'Request',
      Submit: 'Submit',
      FormSubmit: 'Form Submit',
      ErrorBar: 'ErrorBar',
      JumpLinkClick: 'JumpLinkClick',
      Expand: 'Expand',
      Collapse: 'Collapse',
      ClearFilters: 'Clear Filters',
      Apply: 'Apply',
      Close: 'Close',
      GoToCart: 'Go to Cart',
      GoToCheckout: 'Go to Checkout',
      ContinueShopping: 'Continue Shopping',
      AccountMenuDropdown: 'Account Menu Dropdown',
      CategoryDropdown: 'Category Dropdown',
      BuyNoQuantityEntered: 'Buy - No Quantity',
      BuyQuantityEntered: 'Buy - Quantity Entered',
      CategoryAnalyticsSelectedTerm: 'Product Category - Autocomplete Drop Down Click',
      CategoryAnalyticsEnteredTerm: 'Product Category - Search Terms',
      ParameterAnalyticsSelectedTerm: 'Parameter - Autocomplete Drop Down Click',
      ParameterAnalyticsEnteredTerm: 'Parameter - Search Terms',
      ParameterValueAnalyticsSelectedTerm: 'Parameter Value - Autocomplete Drop Down Click',
      ParameterValueAnalyticsEnteredTerm: 'Parameter Value - Search Terms',
      ManufacturerAnalyticsSelectedTerm: 'Manufacturer - Autocomplete Drop Down Click',
      ManufacturerAnalyticsEnteredTerm: 'Manufacturer - Search Terms',
      CreateAccount: 'Create Account',
      Login: 'Login'
    },
    flags: {
      isPopupOn: false,
      stopScollingEventOnFocus: false
    },
    categoryTypes: {
      AdvancedSearch: 'Advanced Search',
      Support: 'Support',
      Datasheets: 'Datasheets',
      UiInteraction: 'UiInteraction',
      SiteMode: 'SiteMode',
      DesignCenter: 'DesignCenter',
      Header: 'Header',
      MegaMenu: 'MegaMenu',
      Login: 'Login',
      Carousel: 'Carousel',
      ReferenceDesigns: 'ReferenceDesigns',
      Search: 'Search',
      Cart: 'Cart',
      ManufacturerList: 'ManufacturerList',
      Social: 'Social',
      Products: 'Products',
      Video: 'Video',
      Newsletter: 'Newsletter',
      Careers: 'Careers',
      Errors: 'Errors',
      Image: 'Image',
      ResearchAndEvents: 'ResearchAndEvents',
      Promotion: 'Promotion',
      MyProjects: 'MyProjects',
      MyArrowLogin: 'MyArrowLogin',
      Indiegogo: 'Indiegogo',
      HeroPromo: 'HeroPromo',
      TrioList: 'TrioList',
      ButtonPromo: 'ButtonPromo',
      LogoList: 'LogoList',
      GenericModule: 'GenericModule',
      IntentToBuy: 'IntentToBuy',
      ProductCategory: 'ProductCategory',
      ProductDetail: 'ProductDetail',
      QuickLinks: 'QuickLinks',
      Backorder: 'Backorder',
      Featured: 'Featured',
      Footer: 'Footer',
      SecondaryPromotion: 'SecondaryPromotion',
      AddToCartModal: 'Add to Cart Modal',
      MyAccount: 'MyAccount',
      ArrowPerks: 'ArrowPerks'
    },
    labelTypes: {
      ApplyAdvancedSearch: 'Apply',
      EngineerChat: 'Engineer Chat',
      AdvancedSearch: 'Advanced Search Module',
      AdvancedSearchClose: 'Close Module',
      RelatedSearch: 'Related',
      Dynamic: 'Dynamic',
      EmailUsClick: 'Email Us Click',
      Region: 'Region',
      Division: 'Division',
      Footer: 'Footer',
      VideoChat: 'VideoChat',
      Email: 'Email',
      Telephone: 'Telephone',
      CartIcon: 'CartIcon',
      CurrencySelector: 'CurrencySelector',
      ArrowDivisions: 'ArrowDivisions',
      LanguageSelector: 'LanguageSelector',
      LoggedIn: 'LoggedIn',
      LoginSignup: 'LoginSignup',
      MyArrow: 'MyArrow',
      ViewCart: 'ViewCart',
      Products: 'Products',
      Register: 'Register',
      ForgotPassword: 'ForgotPassword',
      DesignWithEnvision: 'DesignWithEnvision',
      DesignWithOrCad: 'DesignWithOrCad',
      DatasheetText: 'DatasheetText',
      MissingImage: 'MissingImage',
      NewProject: 'NewProject',
      CurrentProject: 'CurrentProject',
      SelectedProject: 'SelectedProject',
      Twitter: 'Twitter',
      YouTube: 'YouTube',
      LinkedIn: 'LinkedIn',
      Facebook: 'Facebook',
      GooglePlus: 'GooglePlus',
      Weibo: 'Weibo',
      Tudou: 'Tudou',
      Header: 'Header',
      Cart: 'Cart',
      NoSearchResults: 'NoSearchResults',
      GoToArrow: 'GoToArrow',
      GoToMyArrow: 'GoToMyArrow',
      Datasheets: 'Datasheets',
      Researchandevents: 'Researchandevents',
      Designcenter: 'Designcenter',
      Referencedesigns: 'Referencedesigns',
      Success: 'Success',
      Fail: 'Fail',
      UserLockedOut: 'UserLockedOut',
      Sidebar: 'Sidebar',
      Grid: 'Grid',
      Button: 'Button',
      ViewAll: 'ViewAll',
      Recommended: 'Recommended',
      Indiegogo: 'Indiegogo',
      CrossReferences: 'CrossReferences',
      Specifications: 'Specifications',
      RelatedProducts: 'RelatedProducts',
      QuickLinks: 'QuickLinks',
      SecureCheckout: 'SecureCheckout',
      Manufacturer: 'Manufacturer',
      SearchDropDown: 'SearchDropDown',
      ArrowLogo: 'ArrowLogo',
      List: 'List',
      Lower: 'Lower',
      Submit: 'Submit',
      GotAQuestion: 'GotAQuestion',
      Manufacturers: 'Manufacturers',
      ClearBreadcrumb: 'ClearBreadcrumb',
      ChatModule: 'ChatModule',
      MoreInformation: 'MoreInformation',
      SeeAllCategories: 'SeeAllCategories',
      PerksShipping: 'PerksShipping',
      WithFilters: 'With Filters',
      NoFilters: 'No Filters',
      None: 'None',
      SecureCheckoutPaypal: 'Secure Checkout - Paypal',
      CategoryAnalyticsClear: 'Product Category - Clear Text',
      ParameterAnalyticsClear: 'Parameter - Clear Text',
      ParameterValueAnalyticsClear: 'Parameter Value - Clear Text',
      ManufacturerAnalyticsClear: 'Manufacturer - Clear Text',
      ManufacturerCheckbox: 'Manufacturer Checkbox',
      AdditionalParameter: 'Additional Parameter',
      Tab: 'Tab',
      InStock: 'In Stock',
      New: 'New',
      TopSearched: 'Top Searched',
      TopPurchased: 'Top Purchased',
      NonMemberPerksJoin: 'Non-Member - Join ArrowPerks',
      NonMemberPerksLearnMore: 'Non-Member - Learn More'
    },
    eventAttributeNames: {
      event: 'event',
      action: 'action',
      actionOff: 'action-off',
      category: 'category',
      label: 'label',
      mediator: 'mediator'
    },
    delayedPushIds: {
      productDetailImpression: 'ProductDetailImpression'
    },
    promoGroups: [
      'NPI',
      'Top Searched',
      'Top Purchased',
      'Sponsored',
      'Recommended'
    ],
    promoGroupPrefix: 'promo',
    adobeScriptUrlLive: 'https://assets.adobedtm.com/884768c9402e/b692552a5be6/launch-666af34c4a4b.min.js',
    adobeScriptUrlQa: 'https://assets.adobedtm.com/884768c9402e/b692552a5be6/launch-260384f7c661-staging.min.js',
    adobeScriptUrlDev: 'https://assets.adobedtm.com/884768c9402e/b692552a5be6/launch-6b6132af268d-development.min.js'
  },
  imageTypes: {
    png: 'png',
    jpeg: 'jpeg',
    gif: 'gif',
    jpg: 'jpg'
  },
  categoryZero: {
    classes: {
      activePane: 'is-active-pane'
    },
    attributes: {
      level: 'data-arrow-level',
      target: 'data-arrow-target-key'
    }
  },
  env: 'PROD', // Default value overridden by server side config
  accountType: {
    arrowCom: 'arrowCom',
    myArrow: 'myArrow'
  },
  currencyCode: {
    usdCode: 'USD'
  },
  pages: {
    orderDetail: 'orderDetail',
    cartSummary: 'cartSummary'
  },
  transitions: 'transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd',
  breakpoints: {
    phablet: 600,
    laptop: 890,
    desktop: 1024
  },
  chatWindow: {
    chatUrl:
      'https://server.iad.liveperson.net/hc/18784960/?cmd=file&file=visitorWantsToChat&site=18784960&byhref=1&SV!skill=Arrow%20Support',
    width: 360,
    height: 705,
    ctaTimeout: 1000 * 10 // 1 sec * X
  },
  key: {
    down: 40,
    tab: 9,
    left: 37,
    right: 39,
    enter: 13,
    escape: 27,
    up: 38,
    backspace: 8
  },
  regex: {
    alphaNumeric: /^[a-zA-Z0-9]+$/
  },
  promoCodeStorage: {
    key: 'promoCodeOptIn',
    object: {
      promoCodeOptIn: true
    }
  },
  uiElementState: {
    isSelected: 'isSelected',
    isChecked: 'isChecked'
  },
  promoSourceStorage: {
    key: 'promosource'
  },
  events: {
    ajax: {
      success: 'AJAX:success',
      failed: 'AJAX:failed',
      wrappersComplete: 'AJAX:wrappersComplete',
      wrappersContainingRichRelevanceComplete: 'AJAX:wrappersContainingRichRelevanceComplete'
    },

    //Breakpoint listeners.
    breakpoint: {
      get: 'BREAKPOINT_GET',
      any: 'BREAKPOINT_CHANGE:any',
      mobile: 'BREAKPOINT_CHANGE:mobile',
      phablet: 'BREAKPOINT_CHANGE:phablet',
      tablet: 'BREAKPOINT_CHANGE:tablet',
      laptop: 'BREAKPOINT_CHANGE:laptop',
      desktop: 'BREAKPOINT_CHANGE:desktop',
      wide: 'BREAKPOINT_CHANGE:wide'
    },

    chat: {
      online: 'CHAT:online',
      offline: 'CHAT:offline'
    },
    categoryZero: {
      didAddActive: 'CATEGORYZERO:didAddActive',
      didEnterPanel: 'CATEGORYZERO:didEnterPanel',
      clickedViewMore: 'CATEGORYZERO:clickedViewMore',
      openMenu: 'CATEGORYZERO:openMenu',
      closeMenu: 'CATEGORYZERO:closeMenu'
    },
    datasheets: {
      viewerGotoPage: 'DATASHEETS:viewerGotoPage',
      download: 'DATASHEETS:download',
      view: 'DATASHEETS:view'
    },
    referenceDesigns: {
      download: 'REFERENCEDESIGNS:download',
      view: 'REFERENCEDESIGNS:view'
    },

    global: {
      globalisationLoaded: 'GLOBAL:globalisationloaded',
      appIsInitialising: 'GLOBAL:appIsInitialising',
      appIsInitialised: 'GLOBAL:appIsInitialised'
    },

    header: {
      openingDropdownView: 'HEADER:openingDropdownView',
      panelOpened: 'HEADER:panelOpened',
      arrowDivisionsOpened: 'HEADER:arrowDivisionsOpened',
      arrowDivisionsToggle: 'HEADER:arrowDivisionsToggle',
      arrowDivisionsResize: 'HEADER:arrowDivisionsResize',
      minimised: 'HEADER:minimised',
      showTieredPricingNotification: 'HEADER:showTieredPricingNotification',
      hideTieredPricingNotification: 'HEADER:hideTieredPricingNotification'
    },

    footer: {
      subscribe: 'FOOTER:Subscribe'
    },

    // TO DO:
    video: {
      play: 'VIDEO:Play',
      pause: 'VIDEO:Pause',
      chat: 'VIDEO:chat'
    },

    // TO DO:
    youtubePlayer: {
      played: 'YOUTUBEPLAYER:Play',
      paused: 'YOUTUBEPLAYER:Pause',
      done: 'YOUTUBEPLAYER:Done'
    },

    engineer: {
      loadMore: 'ENGINEER:loadMore'
    },

    //loading
    loading: 'loading',
    requestPageReload: 'requestPageReload',
    pageReloading: 'pageReloading',

    offices: {
      showRegion: 'OFFICES:showRegion',
      hideRegion: 'OFFICES:hideRegion',
      showSubRegion: 'OFFICES:showSubRegion'
    },

    masonry: {
      resize: 'MASONRY:resize'
    },
    //search
    search: {
      close: 'SEARCH:close',
      closeAutoComplete: 'SEARCH:closeAutoComplete',
      makeSearch: 'SEARCH:makeSearch',
      typeaheadDisplayResults: 'SEARCH:typeaheadDisplayResults',
      typeaheadHighlightQuery: 'SEARCH:typeaheadHighlightQuery',
      typeaheadHighlightedQuery: 'SEARCH:typeaheadHighlightedQuery',
      typeaheadSearch: 'SEARCH:typeaheadSearch',
      typeaheadSearchFailed: 'SEARCH:typeaheadSearchFailed',
      typeaheadChoosePrevious: 'SEARCH:typeaheadChoosePrevious',
      typeaheadChooseNext: 'SEARCH:typeaheadChooseNext',
      typeaheadChoosePreviousRecent: 'SEARCH:typeaheadChoosePreviousRecent',
      typeaheadChooseNextRecent: 'SEARCH:typeaheadChooseNextRecent',
      typeaheadDisplayRecentSearches: 'SEARCH:typeaheadDisplayRecentSearches',
      makePastSearch: 'SEARCH:makePastSearch',
      fetchedTypeaheadResults: 'SEARCH:fetchedTypeaheadResults',
      showAutoComplete: 'SEARCH:showAutoComplete',
      searchEndReached: 'SEARCH:endReached',
      searchIsOnGoing: 'SEARCH:isOnGoing',
      setIsVisible: 'SEARCH:setIsVisible',
      updateUrl: 'SEARCH:updateUrl',
      populatingResultsStarting: 'SEARCH:populatingResultsStarting',
      populatedResultsComplete: 'SEARCH:populatedResultsComplete',
      sortDropdown: 'SEARCH:sortDropdown',
      searchResultsCount: 'SEARCH:searchResultsCount',
      sortOptionsChanged: 'SEARCH:sortOptionsChanged',
      sortColumnHeading: 'SEARCH:sortColumnHeading',
      columnSortingChanged: 'SEARCH:updateColumnSorting',
      resetColumnSorting: 'SEARCH:resetColumnSorting',
      applyColumnChoice: 'SEARCH:applyColumnChoice',
      categoriesUpdated: 'SEARCH:categoriesUpdated',
      closeColumn: 'SEARCH:closeColumn',
      horizontalScroll: 'SEARCH:horizontalScroll',
      loadMore: 'SEARCH:loadMore',
      loadPage: 'SEARCH:loadPage',
      load: 'SEARCH:load',
      loading: 'SEARCH:loading',
      loaded: 'SEARCH:loaded',
      loadWithFilters: 'SEARCH:loadWithFilters',
      updatePagination: 'SEARCH:updatePagination',
      changePerPage: 'SEARCH:changePerPage',
      setPerPage: 'SEARCH:setPerPage',
      localStorageTypeAhead: 'recentSearches',
      localStorageInstockFilter: 'instockFilter',
      sessionStorageCategoryFilter: 'categoryFilter',
      stockFilterEnabled: '&filters=In+Stock%3AYes&if=y',
      promoGroup: 'promoGroup:',
      inStockValue: 'In+Stock:Yes',
      topPurchased: 'Top Purchased',
      topSearched: 'Top Searched',
      newValueFilter: 'New:true;',
      manufacturerFilter: 'Manufacturer_name:',
      manufacturerType: '&selectedType=manufacturer',
      filterString: '&filters=',
      promoGroupString: '&promoGroupLevel=all',
      unfilteredSearchExecuted: 'unfilteredSearchExecuted'
    },

    productSearch: {
      checkOverflow: 'PRODUCTSEARCH:checkOverflow',
      backButtonRoute: 'PRODUCTSEARCH:backButtonRoute',
      requestApi: 'PRODUCTSEARCH:apiRequest',
      resetContainer: 'PRODUCTSEARCH:resetContainer',
      routerFire: 'PRODUCTSEARCH:routerFire',
      pricingPageLoad: 'PRODUCTSEARCH:pricingPageLoad',
      datasheetToggle: 'PRODUCTSEARCH:datasheetToggle',
      viewDatasheetProducts: 'PRODUCTSEARCH:viewDatasheetProducts'
    },

    registration: {
      confirmation: 'REGISTRATION:confirmation',
      reCaptchaSucess: 'REGISTRATION:reCaptchaSucess',
      mtCaptchaSucess: 'REGISTRATION:mtCaptchaSucess',
      reCaptchaContactUsSucess: 'REGISTRATION:reCaptchaContactUsSucess',
      mtCaptchaContactUsSucess: 'REGISTRATION:mtCaptchaContactUsSucess'
    },

    logout: {
      crossDomainRequestCompletion: 'LOGOUT:crossDomainRequestCompletion'
    },

    region: {
      selection: 'REGION:selection'
    },

    datasheetSearch: {
      openProducts: 'DATASHEETSEARCH:openProducts',
      closeProducts: 'DATASHEETSEARCH:closeProducts'
    },

    manufacturer: {
      viewPage: 'MANUFACTURER:viewPage'
    },

    filters: {
      open: 'PRODUCTFILTER:open',
      filterAccordionClicked: 'PRODUCTFILTER:filterAccordionClicked',
      filterCleared: 'FILTER:cleared',
      filtersComplete: 'FILTERS:complete',
      filtersClear: 'FILTERS:clear',
      filtersCancel: 'FILTERS:cancel',
      filtersClose: 'FILTERS:close',
      filtersExpand: 'FILTERS:expand',
      filtersApply: 'FILTERS:apply', // Attempt to apply filters
      orientationChange: 'FILTERS:orientationChange',
      add: 'FILTERS:add',
      controllerAdd: 'FILTERS:controller:add',
      remove: 'FILTERS:remove',
      controllerRemove: 'FILTERS:controller:remove',
      tagRemove: 'FILTERS:tag:remove',
      reset: 'FILTERS:reset',
      update: 'FILTERS:update',
      load: 'FILTERS:load', // Ask for the filters to be loaded
      loading: 'FILTERS:loading', // Once the request has been sent to the server for new filter data
      received: 'FILTERS:received', // When the data has been returned, but before client has processed data
      loaded: 'FILTERS:loaded', // Once the filters have finished loading and processing
      heightChanged: 'FILTERS:heightChanged',
      filterSearch: 'FILTERS:filterSearch',
      rendered: 'FILTERS:rendered'
    },

    cart: {
      apiError: 'Error',
      add: 'CART:add', // Attempt to add
      addMultiple: 'CART:addMultiple', // Attempt to add multiple buying options
      adding: 'CART:adding', // Adding, request sent to server
      added: 'CART:added', // Added - response from server
      updated: 'CART:updated', // Updated - cart details have been fetched
      updateFailed: 'CART:updateFailed', // Update Failed - cart details failed during fetch
      failedToAdd: 'CART:failedToAdd', // Error from server
      quantityRestriction: 'CART:quantityRestriction',
      showProductForm: 'CART:showProductForm',
      showBackorderForm: 'CART:showBackorderForm',
      showSingleBuyingOptionsBackorderForm: 'CART:showSingleBuyingOptionsBackorderForm',
      showDepleteStockBackorderForm: 'CART:showDepleteStockBackorderForm',
      userInfoSet: 'CART:userInfoSet',
      userInfoError: 'CART:userInfoError',
      removeItem: 'CART:removeItem',
      removeAllItems: 'CART:removeAllItems',
      entryUpdated: 'CART:entryUpdated',
      updateEntry: 'CART:updateEntry',
      openRemoveItemModal: 'CART:openRemoveItemModal',
      openUnableToRemoveModal: 'CART:openUnableToRemoveModal',
      removeCart: 'CART:removeCart'
    },

    forgotPassword: {
      confirmation: 'FORGOTPASSWORD:confirmation',
      confirmed: 'FORGOTPASSWORD:confirmed',
      loginErrorLocked: 'user.service.account.locked',
      loginProxyErrorLocked: 'external.service.user.locked',
      loginErrorNotFound: 'user.service.user.not.found',
      loginUserProxyErrorNotFound: 'external.service.not.found',
      forgottenUser: 'user.service.account.forgotten',
      userAllreadyExists: 'external.service.user.exists',
      externalForgottenUser: 'external.service.user.forgotten',
      commerceCloudForgottenUser: 'ForgottenCustomerError',
      userAlreadyCreated: 'user.id.already.used'
    },

    resetPassword: {
      confirmation: 'RESETPASSWORD:confirmation',
      confirmed: 'RESETPASSWORD:confirmed'
    },

    designCenter: {
      changeProjectName: 'DESIGNCENTER:changeProjectName',
      fetchProjects: 'DESIGNCENTER:fetchProjects',
      fetchProjectsForDocument: 'DESIGNCENTER:fetchProjectsForDocument',
      fetchProjectsForProduct: 'DESIGNCENTER:fetchProjectsForProduct',
      fetchProjectsForDocumentFailed: 'DESIGNCENTER:fetchProjectsForDocumentFailed',
      fetchProjectsForProductFailed: 'DESIGNCENTER:fetchProjectsForProductFailed',
      createProject: 'DESIGNCENTER:createProject',
      replaceDesign: 'DESIGNCENTER:replaceDesign',
      projectDesignReplaced: 'DESIGNCENTER:projectDesignReplaced',
      replaceDesignFailed: 'DESIGNCENTER:replaceDesignFailed',
      copyProject: 'DESIGNCENTER:copyProject',
      createProjectFailed: 'DESIGNCENTER:createProjectFailed',
      deleteProject: 'DESIGNCENTER:deleteProject',
      deleteProjectFailed: 'DESIGNCENTER:deleteProjectFailed',
      projectCreatedOnServer: 'DESIGNCENTER:projectCreatedOnServer',
      projectDeletedOnServer: 'DESIGNCENTER:projectDeletedOnServer',
      projectsFetchedFromServer: 'DESIGNCENTER:projectsFetchedFromServer',
      projectsFetchedForDocument: 'DESIGNCENTER:projectsFetchedForDocument',
      projectsFetchedForProduct: 'DESIGNCENTER:projectsFetchedForProduct',
      syncDocumentProjects: 'DESIGNCENTER:syncDocumentProjects',
      syncProductProjects: 'DESIGNCENTER:syncProductProjects',
      documentProjectsSynced: 'DESIGNCENTER:documentProjectsSynced',
      documentProjectsSyncFailed: 'DESIGNCENTER:documentProjectsSyncFailed',
      productProjectsSynced: 'DESIGNCENTER:productProjectsSynced',
      productProjectsSyncFailed: 'DESIGNCENTER:productProjectsSyncFailed'
    },

    session: {
      checkLoggedInState: 'SESSION:checkLoggedInState',
      loggedInStateChecked: 'SESSION:loggedInStateChecked',
      unauthorizedResponseReceived: 'SESSION:unauthorizedResponseReceived'
    },

    megaMenu: {
      open: 'MEGAMENU:open',
      close: 'MEGAMENU:close',
      categoryOpen: 'MEGAMENU:categoryOpen',
      categoryClick: 'MEGAMENU:categoryClick'
    },

    //Dom event listeners
    ui: {
      DOMContentLoaded: 'UI:DOMContentLoaded',
      ajaxContentLoaded: 'UI:ajaxContentLoaded',
      sitecorePlaceholderLoaded: 'UI:sitecorePlaceholderLoaded',
      load: 'UI:load',
      resize: 'UI:resize',
      resizeThrottle: 'UI:resize:throttle',
      scroll: 'UI:scroll',
      scrollThrottle: 'UI:scroll:throttle'
    },

    error: {
      generic: 'ERROR:generic'
    },

    share: {
      modal: 'SHARE:modal',
      email: 'SHARE:email'
    },

    modal: {
      opening: 'MODAL:opening',
      closing: 'MODAL:closing'
    },

    richRelevance: {
      placementsReceived: 'RICHRELEVANCE:placementsReceived',
      initialise: 'RICHRELEVANCE:initialise',
      shouldR3Flush: 'RICHRELEVANCE:shouldR3Flush',
      addRrComponent: 'RICHRELEVANCE:addRrComponent'
    },

    showHide: {
      hideGroupHeader: 'SHOWHIDE_HIDE:GroupHeader'
    },

    videoDesk: {
      showMoreAgents: 'agentlist:showmore'
    },
    promotions: {
      optInChange: 'OPT_IN:valueChanged'
    },
    productImpressions: {
      viewed: 'PRODUCT_IMPRESSION:viewed',
      check: 'PRODUCT_IMPRESSION:check',
      checkListElement: 'PRODUCT_IMPRESSION:checkListElement',
      productElementsHidden: 'PRODUCT_IMPRESSION:productElementsHidden',
      productElementsVisible: 'PRODUCT_IMPRESSION:productElementsVisible'
    },
    impressions: {
      viewed: 'IMPRESSION:viewed',
      check: 'IMPRESSION:check',
      checkListElement: 'IMPRESSION:checkListElement'
    },

    carousel: {
      slideChanged: 'CAROUSEL:slideChanged'
    },

    scrollTo: 'SCROLL_TO:element',

    pricing: {
      pdpBuyingOptions: 'PRICING:BuyingOptions',
      received: 'PRICING:received',
      groupedBuyingOptionsReceived: 'PRICING:groupedBuyingOptionsReceived'
    },

    buyingOptions: {
      quantityUpdated: 'BUYING_OPTIONS:quantityUpdated',
      updateQuantity: 'BUYING_OPTIONS:updateQuantity',
      refreshQuantity: 'BUYING_OPTIONS:refreshQuantity',
      changePackaging: 'BUYING_OPTIONS:changePackaging',
      changeRegion: 'BUYING_OPTIONS:changeRegion',
      regionChanged: 'BUYING_OPTIONS:regionChanged',
      updateModels: 'BUYING_OPTIONS:updateModels'
    },

    cmsModal: {
      show: 'CMS_MODAL:show'
    }
  },
  state: {
    header: {
      typeaheadIsOpen: 'typeaheadIsOpen'
    },
    breakpoint: 'breakpoint'
  },
  classes: {
    loadingClass: 'loading',
    reloading: 'PageReloading',
    isLoading: 'is-loading',
    isWhite: 'is-white',
    isShowing: 'is-showing',
    isSelected: 'is-selected',
    isVisible: 'is-visible',
    isHidden: 'is-hidden',
    isHiddenMobile: 'is-hidden-mobile',
    isActive: 'is-active',
    isDisabled: 'is-disabled',
    isFaded: 'is-faded',
    isInvalid: 'is-invalid',
    isValid: 'is-valid',
    isTransitioning: 'is-transitioning',
    isOpen: 'is-open',
    isClosed: 'is-closed',
    isEmpty: 'is-empty',
    uHide: 'u-hide',
    isAccepted: 'is-accepted',
    remodalIsActive: 'remodal-is-active',
    hasError: 'hasError',
    hasSearchFiltersOpen: 'has-search-filters-open',
    hasMinimisedHeader: 'has-minimised-header',
    hasDivisionsMenu: 'has-divisions-menu-open',
    hasDuplicate: 'has-duplicate',
    hasCustomValidationError: 'has-custom-validation-error',
    hasHeaderDropdown: 'has-header-dropdown-open',
    hasMyCartDropdown: 'has-my-cart-dropdown-open',
    hasAccountDropdown: 'has-account-dropdown-open',
    hasStickyHeader: 'hasStickyHeader',
    hasmegaMenuOpen: 'has-megamenu-open',
    megamenuOpen: 'megamenu-open',
    hasMobileMinimisedHeader: 'has-mobile-minimised-header',
    isEditorMode: 'is-editor-mode',
    isShowingTypeahead: 'is-showing-typeahead',
    isShowingAutoComplete: 'is-showingAutoComplete',
    refineProductResults: 'SearchResults-loadMore--refine',
    isLive: 'is-live',
    inCart: 'is-in-cart',
    hasLoadMore: 'has-loadMore',
    isDatasheetMode: 'is-datasheet-mode',
    isDatasheetProductsOpen: 'is-datasheet-products-open',
    isDatasheetProductClosed: 'is-datasheet-product-closed',
    isSingleDatasheetMode: 'is-single-datasheet-mode',
    keyActive: 'Key--active',
    showStickySearch: 'showStickySearch',
    isHorizontalSearch: 'Layout-Search--horizontal',
    isStickyHeader: 'is-sticky-header',
    isMegaMenuOpen: 'is-megamenu-open',
    isDivisionsMenu: 'is-divisions-menu-open',
    isHeaderDropdown: 'is-header-dropdown-open',
    isMinimisedHeader: 'is-minimised-header',
    visuallyHidden: 'visuallyhidden',
    productLandingTabbedContentTabs: 'ProductLanding-tabbedContent-tabs',
    hasAdvancedSearchOpen: 'has-AdvancedSearch-open',
    advancedSearchValidationGroup: '.AdvancedSearchContent-search-element--validation-group',
    advancedSearchParametricValidationGroup: '.AdvancedSearchContent-search-element-split-left--validation-group',
    advancedSearchDisabledLabel: 'AdvancedSearchContent-disabledLabel',
    tieredPricing: 'Tiered-Pricing'
  },
  cacheCookieSettings: {
    cookies: 'arrowcurrency=a&isocode=is&culture=cu&IsNewUser=ne&RedirectFromLogin=re',
    maxAge: 232223
  },
  cookies: {
    defaultDomain: '.arrow.com',
    currency: 'arrowcurrency',
    appConfig: 'arrowappconfig',
    headerTopBarDismissed: 'headerTopBarDismissed',
    headerTopBarCookieExpiration: 10, //days
    arrowfedExpiration: 1740000,
    myArrowNotificationCookieExpiration: 30, //days
    myProjectsListingHowTo: 'myprojectslistinghowto',
    acceptedCookiePolicy: typeof Arrow !== 'undefined' && typeof Arrow.cookiePolicyVersion !== 'undefined'
      ? Arrow.cookiePolicyVersion
      : 'acceptedCookiePolicy',
    region: 'wwwregion',
    regionLogin: 'regionLogin',
    myArrow: 'MyArrowUser',
    arrowFed: 'arrowfed',
    arrowCache: 'arrowcache',
    sessionExtend: 'sessionextend',
    fromLogin: 'RedirectFromLogin',
    userFirstName: '_aId',
    arrowLanguage: 'website#lang',
    myArrowNotification: 'MyArrowNotification',
    csrSignedInAsCustomer: 'csrSignedInAsCustomer',
    promotionalGiveaway: {
      userGuidCookie: 'PromotionalGiveawayGUID',
      purchaseActionCompleteCookie: 'IsPromoGiveawayPurchaseActionAvailable',
      referralGuidCookie: 'PromotionalGiveawayReferralGUID',
      userGuidCookieExpiration: 30 // days
    },
    marketingTracking: {
      userAnonymousIdGidCookie: '_gid',
      userAnonymousIdGACookie: '_ga'
    },
    accessToken: 'accesstoken',
    hideTieredPricingNotification: 'hideTieredPricingNotification',
    countryCode: 'countryCode',
    cloudUserId: 'cloudUserId',
    customerPriceGroup: 'customerPriceGroup'
  },
  sessionVariables: {
    marketingTracking: {
      userJustLoggedInCookie: 'UserJustLoggedIn',
      userJustTriedToRegisterCookie: 'UserJustTriedToRegister'
    },
    header: {
      personalInfo: 'Header',
      b2busers: 'b2busers'
    },
    referrerKey: 'referrer'
  },
  urls: {
    careers: 'http://arrow.loop.jobs/',
    richRelevanceBaseUrl: '//integration.richrelevance.com/rrserver',
    contactSupport: {
      emailUs: '/helpcenter/emailusformdatatoeloqua'
    },
    authorized: {
      api: '/api/authorized'
    },
    typeahead: '/api/AutoComplete',
    megamenu: '/megamenu/',
    errorParam: {
      base: 'error'
    },
    goToUrlParam: {
      base: 'goToUrl',
      firstParam: '?goToUrl=',
      followingParam: '&goToUrl='
    },
    modeParam: {
      arrowCom: {
        firstParam: '?mode=arrowCom',
        followingParam: '&mode=arrowCom',
        value: 'arrowCom'
      },
      myArrow: {
        value: 'myArrow'
      }
    },
    projects: {
      api: '/api/myprojects/projects',
      documentsApi: '/api/myprojects/projects/documents',
      productsApi: '/api/myprojects/projects/products'
    },
    engineerMessage: '/api/CustomerSupport/SendEngineerEmail',
    indiegogoContact: '/api/CustomerSupport/SendIndiegogoEmail',
    cart: {
      defaultImage: '/static/img/icons/apple-touch-icon-60x60.png',
      getCartHandover: 'https://uat.cms.arrow.com/en/api/carthandover'
    },
    search: {
      results: 'supplied by data attribute',
      filters: 'supplied by data attribute',
      relevantResults: '/api/products/productsearchrelevanceresults'
    },
    advancedSearch: {
      advancedFilter: '/productsearch/searchfiltersajax',
      advancedSearchLists: '/api/products/getadvancedsearchlists',
      advancedCategoriesForManufacturers: '/api/products/getcategoriesformanufacturers?manufacturerId='
    },
    users: {
      api: '/api/users',
      perks: '/account/arrow-perks'
    },
    order: {
      getOrderDetails: 'https://cart.arrow.com/server-webapp/api/getOrderHistoryDetails'
    },
    login: {
      baseRedirectUrl: 'components.arrow.com/part/search/1?region=',
      registerUrl: 'components.arrow.com/federationregistrationservice/fed_regpage.jsp?gotoURL=',
      forgotPasswordUrl: '/login/forgotpassword?username=',
      reCaptchaSucess: 'LOGIN:reCaptchaSucess',
      mtCaptchaSucess: 'LOGIN:mtCaptchaSucess'
    },
    marketingTracking: {
      apiUrl: '/marketingtracking',
      trackRegistration: '/trackregistration',
      trackLogin: '/tracklogin',
      trackAddToCart: '/trackaddtocart',
      trackSocialShare: '/tracksocialshare',
      trackDatasheet: '/trackdatasheet',
      trackReferenceDesign: '/trackreferencedesign',
      saveToMyProjects: '/savetomyproject',
      trackManufacturer: '/trackmanufacturer',
      trackArticlesAndEvents: '/trackViewArticlesVideosEvents'
    },
    cmsModal: '/api/Notifications/GetCmsModalContent',
    contentService: {
      ajaxField: '/ajaxrendering/ajaxfield',
      singleItem: '/sitecore/api/ssc/item',
      image: '/ajaxrendering/image',
      link: '/ajaxrendering/link',
      imageLink: '/ajaxrendering/imagelink'
    },
    bomTool: '/bom-tool',
    searchApp: {
      url: 'apps/search',
      autoComplete: 'api/autocomplete'
    },
    referenceDesigns: '/reference-designs/',
    articlesAndVideos: '/research-and-events/',
    loginPage: '/login',
    samtecPage: '/en/samtec-product-selector',
    newProducts: {
      getFeaturedCategories: '/api/category/getFeaturedCategories',
      newProductSearchQuerystring: '?npi=true&cat='
    },
    pdpPage: '/products',
    kitbuilder: '/kitbuilder',
    searchWithQueryPage: '/products/search?q=',
    pdpLitePage: '/apps/Samtec/configurator',
    samtecTool: {
      isPartInCatalog: '/api/products/ispartincatalog'
    },
    indiegogo: {
      searchCampaigns: '/api/indiegogo/searchcampaigns',
      campaign: '/indiegogo/'
    },
    hashes: {
      quoteLink: 'quoteLink'
    }
  },
  headerHeight: {
    desktopFull: 210, // at 1024
    desktopMinimised: 50,
    tablet: 190, // at 890
    mobile: 84
  },
  minimisedHeader: {
    breakpoint: 890
  },
  breakpoint: {
    mobile: 0,
    phablet: 1,
    tablet: 2,
    laptop: 3,
    desktop: 4,
    wide: 5
  },
  search: {
    maxResultsCount: 120,
    autoCompleteCharacterTriggerLength: 2,
    resultTypeProduct: 'Product',
    resultTypeDatasheet: 'Datasheet',
    resultTypeDatasheetSeeAll: 'DatasheetSeeAll',
    noDatasheetUrl: '/2c9c2d82b92b895046a570b78ca93e46414398a6/nods.pdf',
    dataSheetMaxResult: 3,
    pastSearchListItems: 5
  },
  productSearch: {
    currentResultsAvailable: 0
  },
  // Error levels used by error modal
  error: {
    level: {
      error: 'Error',
      warning: 'Warning',
      info: 'Info'
    },
    type: {
      timeout: 'TIMEOUT'
    }
  },
  cart: {
    maxMiniCartItemCount: 5,
    apiError: {
      alreadyInCart: 'shoppingCart.alreadyInCart',
      couldNotFindItem: 'shoppingCart.couldNotFindItem',
      maxQuantity: 'shoppingCart.quantityUnavailable',
      priceChange: 'shoppingCart.priceChange',
      promoInvalid: 'promo.raw'
    },
    noItemsInCart: 'noItemsInCart',
    openDrawer: 'is-active'
  },
  isHiDef: 0,
  registrationModelDefaults: {
    companyName: 'company',
    phoneNumber: 'telephone',
    country: 'AQ',
    source: 'arrowCom',
    fmt: 'JSON'
  },
  videoDesk: {
    availability: {
      unavailable: 'unavailable',
      video: 'video',
      text: 'text'
    }
  },
  countryCodes: {
    uk: 'UK',
    eloquaUK: 'GB',
    us: 'US',
    ca: 'CA'
  },
  autoComplete: {
    selectedTypeSuggestions: 'suggestions'
  },
  customerSpecificPricing: {
    prefix: 'NAC_C_',
    localStorageName: 'customerNumbers'
  },
  samtecTool: {
    SamtecManufacturerId: '{25EC2625-A2B3-4541-96AD-C45D40000910}',
    iframeUrl: '//webassistants.partcommunity.com/23d-libs/samtec/search/resolve.html',
    iframeOriginUrl: 'https://webassistants.partcommunity.com'
  },
  pdpLite: {
    productSpec: 'Product Specification',
    catalogPage: 'Catalog Page',
    rohsCompliant: 'RoHS compliant',
    langEng: 'eng',
    imageUrl: 'https://d289i18z47mg2a.cloudfront.net/kineticimages',
    docUrl: 'http://suddendocs.samtec.com',
    dataApiUrl: 'https://kineticapilive-products.samtec.com/api',
    docApiUrl: 'https://kineticapilive-documents.samtec.com/api',
    pdpLiteArticlesVideos: '/api/products/GetTagsforArticles',
    getManufacturerProductDetailUrl: '/apps/search/api/manufacturerproductdetail',
    getNoncatalogProductDetailUrl: '/apps/search/api/noncatalogedproductdetail',
    getProductSeriesOptionUrl: '/apps/search/api/productseriesoption',
    contentGrid: '/contentgrid/initialpageajax',
    getPromotionalItemUrl: '/promotional/promotionalitem',
    getPromotionalItemsUrl: '/promotional/getpromotionalitems',
    storageKey: 'pdplite',
    se: 'SE',
    samtec: 'Samtec'
  },
  utmStorage: {
    key: 'utm'
  },
  seo: {
    inStockUrl: 'http://schema.org/InStock',
    outOfStockUrl: 'http://schema.org/OutOfStock',
    seoPlaceHolder: 'SeoPlaceHolder'
  },
  filters: {
    promoGroup: 'promoGroup',
    new: 'New',
    inStock: 'In Stock',
    manufacturer: 'Manufacturer_name'
  },
  languages: {
    english: 'en'
  },
  customReel: {
    sourcePartIdSuffix: '-AR'
  },
  hybris: {
    baseUrl: 'https://qa.arrow.com/commerce-cc/arrowwebservices/v2/arrow/',
    tokenUrl: 'https://qa.arrow.com/commerce-cc/arrowwebservices/v2/arrow/token',
    cartPath: 'users/anonymous/carts',
    anonymous: 'anonymous',
    current: 'current',
    anonymousid: 'cartida',
    currentid: 'cartidc',
    customReel: 'CUSTOMREEL',
    arrowCustomReel: 'ARROWCUSTOMREEL',
    arrowReelFee: 'CUSTOM-REEL-FEE',
    importTariff: 'US-TARIFF-ON-CHINA-ELIGIBLE',
    restrictedProduct: 'cart.products.restricted.message',
    handlingFee: 'HANDLING',
    cartExpiration: 30,
    isOnProfileUpdate: 'isOnProfileUpdate'
  },
  masterDataMicroServicesSettings: {
    baseUrl: 'https://qa-int.arrow.com/services/master/'
  },
  myAccountSettings: {
    arrowPerks: 'arrowperks',
    joinArrowPerks: 'joinarrowperks'
  },
  bomToolSettings: {
    connectionTimeoutInMilliSeconds: 20000
  },
  productAPI: {
    baseUrl: 'http://api.cc.uw1.arwcloud.net'
  },
  b2bSecretKeys: ['arrowCustomerId', 'blocked', 'cloudUserId', 'creditLimit', 'customerIPAddress', 'displayUid', 'email', 'loyalty', 'navNo', 'uid']
};

_.extend(uikit.config, config);
module.exports = uikit.config;



// WEBPACK FOOTER //
// ./assets/js/config.js